const apiBase = () => process.env.REACT_APP_BACKEND_URL || "";

async function gamePost(token, action, body = {}) {
  const res = await fetch(`${apiBase()}/game/${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || data.error || `Request failed (${res.status})`);
  }
  return data;
}

export function gameGetState({ token, currentTheme }) {
  return gamePost(token, "get-state", { currentTheme });
}

export function gameAddPlayer({ token, currentTheme, playerName }) {
  return gamePost(token, "add-player", { currentTheme, playerName });
}

export function gameDeletePlayer({ token, currentTheme, playerId }) {
  return gamePost(token, "delete-player", { currentTheme, playerId });
}

export function gameSplitTeams({ token, currentTheme }) {
  return gamePost(token, "split-teams", { currentTheme });
}

export function gameUpdateState({ token, currentTheme, patch }) {
  return gamePost(token, "update-state", { currentTheme, ...patch });
}

export function gameStartQuestion({ token, currentTheme, questionId }) {
  return gamePost(token, "start-question", { currentTheme, questionId });
}

export function gameSubmitAnswer({ token, currentTheme, questionId, selectedPlayerId, optionNo }) {
  return gamePost(token, "submit-answer", {
    currentTheme,
    questionId,
    selectedPlayerId,
    optionNo,
  });
}

export function gameRevealAnswer({ token, currentTheme }) {
  return gamePost(token, "reveal-answer", { currentTheme });
}

export function gameStrike({ token, currentTheme, team, action }) {
  return gamePost(token, "strike", { currentTheme, team, action });
}

export function gameDiscussion({ token, currentTheme, start }) {
  return gamePost(token, "discussion", { currentTheme, start });
}

export function gameLeaderboard({ token, currentTheme }) {
  return gamePost(token, "leaderboard", { currentTheme });
}

export function gameRestartTimer({ token, currentTheme }) {
  return gamePost(token, "restart-timer", { currentTheme });
}
